export const fonts = [
  'Roboto',
  'Open Sans',
  'Lato',
  'Montserrat',
  'Roboto Condensed',
  'Source Sans Pro',
  'Oswald',
  'Raleway',
  'Roboto Mono',
  'Poppins',
  'Roboto Slab',
  'Merriweather',
  'Noto Sans',
  'PT Sans',
  'Ubuntu',
  'Playfair Display',
  'Open Sans Condensed',
  'Muli',
  'PT Serif',
  'Lora',
  'Nunito',
  'Slabo 27px',
  'Titillium Web',
  'Fira Sans',
  'Rubik',
  'Noto Sans JP',
  'Work Sans',
  'Noto Serif',
  'Nanum Gothic',
  'Quicksand',
  'PT Sans Narrow',
  'Arimo',
  'Noto Sans KR',
  'Inconsolata',
  'Nunito Sans',
  'Dosis',
  'Oxygen',
  'Heebo',
  'Cabin',
  'Karla',
  'Libre Baskerville',
  'Bitter',
  'Josefin Sans',
  'Crimson Text',
  'Libre Franklin',
  'Varela Round',
  'Noto Sans TC',
  'Source Code Pro',
  'Hind',
  'Anton',
  'Indie Flower',
  'Lobster',
  'Fjalla One',
  'Barlow',
  'Abel',
  'Mukta',
  'Arvo',
  'Source Serif Pro',
  'Dancing Script',
  'Pacifico',
  'Exo 2',
  'Shadows Into Light',
  'Merriweather Sans',
  'Yanone Kaffeesatz',
  'Asap',
  'Overpass',
  'Questrial',
  'Abril Fatface',
  'Bree Serif',
  'EB Garamond',
  'Archivo Narrow',
  'Acme',
  'Barlow Condensed',
  'Comfortaa',
  'IBM Plex Sans',
  'Kanit',
  'Cairo',
  'Amatic SC',
  'Teko',
  'Signika',
  'Maven Pro',
  'Exo',
  'Play',
  'Noto Sans SC',
  'Fira Sans Condensed',
  'Catamaran',
  'Hind Siliguri',
  'Righteous',
  'Ubuntu Condensed',
  'PT Sans Caption',
  'Patua One',
  'Domine',
  'Assistant',
  'Crete Round',
  'Ropa Sans',
  'Cinzel',
  'Vollkorn',
  'Cormorant Garamond',
  'Prompt',
  'Monda',
  'Permanent Marker',
  'ABeeZee',
  'Hind Madurai',
  'Rajdhani',
  'Francois One',
  'Cuprum',
  'Rokkitt',
  'Caveat',
  'Courgette',
  'Satisfy',
  'Zilla Slab',
  'Amiri',
  'Pathway Gothic One',
  'Barlow Semi Condensed',
  'News Cycle',
  'Alegreya Sans',
  'Alegreya',
  'Fredoka One',
  'Fira Sans Extra Condensed',
  'Noticia Text',
  'Alfa Slab One',
  'Martel',
  'Istok Web',
  'Kalam',
  'Cardo',
  'Old Standard TT',
  'Kaushan Script',
  'Nanum Myeongjo',
  'Bowlby One SC',
  'Great Vibes',
  'Tinos',
  'Tajawal',
  'Staatliches',
  'Archivo Black',
  'Lobster Two',
  'Baloo Bhai',
  'Quattrocento Sans',
  'Gloria Hallelujah',
  'Cantarell',
  'Sacramento',
  'Orbitron',
  'Vidaloka',
  'Advent Pro',
  'IBM Plex Serif',
  'Patrick Hand',
  'M PLUS 1p',
  'Cookie',
  'Volkhov',
  'Didact Gothic',
  'Luckiest Guy',
  'Frank Ruhl Libre',
  'Quattrocento',
  'Concert One',
  'Noto Serif JP',
  'Gothic A1',
  'Neuton',
  'Economica',
  'Poiret One',
  'Sanchez',
  'Passion One',
  'Josefin Slab',
  'BenchNine',
  'Prata',
  'Hind Vadodara',
  'Russo One',
  'Spectral',
  'Playfair Display SC',
  'Special Elite',
  'Neucha',
  'Yrsa',
  'Handlee',
  'Hind Guntur',
  'Parisienne',
  'Changa',
  'Gudea',
  'Philosopher',
  'Ruda',
  'Bangers',
  'Archivo',
  'Sawarabi Mincho',
  'Ultra',
  'Chivo',
  'Quantico',
  'Cabin Condensed',
  'Asap Condensed',
  'Montserrat Alternates',
  'Yantramanav',
  'Nanum Gothic Coding',
  'Paytone One',
  'Armata',
  'Saira Extra Condensed',
  'M PLUS Rounded 1c',
  'Arapey',
  'Monoton',
  'Khand',
  'Viga',
  'Pontano Sans',
  'Alice',
  'Lalezar',
  'Unica One',
  'Marck Script',
  'Hammersmith One',
  'Taviraj',
  'Amaranth',
  'Yellowtail',
  'Bad Script',
  'Gentium Basic',
  'Enriqueta',
  'Tangerine',
  'PT Mono',
  'Architects Daughter',
  'Saira Condensed',
  'Glegoo',
  'Sigmar One',
  'Gochi Hand',
  'Audiowide',
  'Gentium Book Basic',
  'Merienda',
  'Varela',
  'Karma',
  'Actor',
  'Adamina',
  'Saira',
  'Julius Sans One',
  'Homemade Apple',
  'Pridi',
  'Sorts Mill Goudy',
  'Fugaz One',
  'Nanum Pen Script',
  'Mitr',
  'Signika Negative',
  'Baloo',
  'Ubuntu Mono',
  'Press Start 2P',
  'Shadows Into Light Two',
  'Unna',
  'Kreon',
  'Cantata One',
  'Allura',
  'Sarala',
  'Sintony',
  'Pragati Narrow',
  'Encode Sans Condensed',
  'Cormorant',
  'Rock Salt',
  'Rasa',
  'Lusitana',
  'Yeseva One',
  'Covered By Your Grace',
  'Oleo Script',
  'Alegreya Sans SC',
  'Sarabun',
  'El Messiri',
  'Scada',
  'Jaldi',
  'Boogaloo',
  'Marvel',
  'Playball',
  'Tenor Sans',
  'IBM Plex Mono',
  'Reenie Beanie',
  'Khula',
  'Damion',
  'Carter One',
  'PT Serif Caption',
  'Abhaya Libre',
  'Arbutus Slab',
  'Jura',
  'Palanquin',
  'Pinyon Script',
  'Antic Slab',
  'Alex Brush',
  'Marcellus',
  'Forum',
  'Chewy',
  'Coda',
  'Markazi Text',
  'Nothing You Could Do',
  'Mr Dafoe',
  'Squada One',
  'Basic',
  'Fauna One',
  'Bevan',
  'Michroma',
  'Spinnaker',
  'Marmelad',
  'Lustria',
  'Electrolize',
  'Rubik Mono One',
  'Sawarabi Gothic',
  'Candal',
  'Alef',
  'Aclonica',
  'Rancho',
  'Cousine',
  'Aldrich',
  'Reem Kufi',
  'VT323',
  'Molengo',
  'Encode Sans',
  'Average',
  'Niramit',
  'Caveat Brush',
  'Sunflower',
  'Black Ops One',
  'Lilita One',
  'Rambla',
  'Nobile',
  'Allerta',
  'Fredericka the Great',
  'Encode Sans Semi Condensed',
  'Days One',
  'Rufina',
  'Scheherazade',
  'Cabin Sketch',
  'Antic',
  'Fira Mono',
  'Coming Soon',
  'Italianno',
  'Niconne',
  'Overlock',
  'Share Tech Mono',
  'Just Another Hand',
  'Space Mono',
  'Biryani',
  'Allerta Stencil',
  'Knewave',
  'Leckerli One',
  'Mukta Malar',
  'Lateef',
  'Saira Semi Condensed',
  'Radley',
  'Arima Madurai',
  'Hanuman',
  'Oranienbaum',
  'Copse',
  'Norican',
  'Telex',
  'Grand Hotel',
  'Rochester',
  'Syncopate',
  'Aladin',
  'DM Sans',
  'Arsenal',
  'Itim',
  'Noto Serif SC',
  'Mountains of Christmas',
  'Cinzel Decorative',
  'Lekton',
  'Share',
  'Martel Sans',
  'Baloo Bhaina',
  'Shrikhand',
  'Berkshire Swash',
  'DM Serif Text',
  'Miriam Libre',
  'Gruppo',
  'Londrina Solid',
  'Marcellus SC',
  'Palanquin Dark',
  'Allan',
  'Halant',
  'Lemonada',
  'Overpass Mono',
  'Anonymous Pro',
  'Magra',
  'Kameron',
  'Annie Use Your Telescope',
  'Nanum Brush Script',
  'Coda Caption',
  'Ramabhadra',
  'Racing Sans One',
  'Krub',
  'Bai Jamjuree',
  'Kosugi Maru',
  'Changa One',
  'Alegreya SC',
  'Graduate',
  'Judson',
  'Suranna',
  'Yesteryear',
  'Nixie One',
  'Bentham',
  'Coustard',
  'Pattaya',
  'Caudex',
  'Petit Formal Script',
  'Mada',
  'Belleza',
  'Slabo 13px',
  'Contrail One',
  'Poly',
  'Carrois Gothic',
  'Mali',
  'Carme',
  'Buenard',
  'Do Hyeon',
  'Cambo',
  'Aleo',
  'Capriola',
  'Sriracha',
  'Jockey One',
  'Arizonia',
  'Rosario',
  'Encode Sans Semi Expanded',
  'Noto Serif TC',
  'Trirong',
  'Eczar',
  'Voltaire',
  'Herr Von Muellerhoff',
  'Titan One',
  'Bungee Inline',
  'Sue Ellen Francisco',
  'Bungee',
  'GFS Didot',
  'Cambay',
  'Red Hat Text',
  'Calligraffitti',
  'Kelly Slab',
  'Merienda One',
  'Bubblegum Sans',
  'Maitree',
  'Gilda Display',
  'Kristi',
  'Faustina',
  'Delius',
  'DM Serif Display',
  'Oxygen Mono',
  'Love Ya Like A Sister',
  'Average Sans',
  'Goudy Bookletter 1911',
  'Anaheim',
  'Baloo Bhaijaan',
  'Trocchi',
  'ZCOOL XiaoWei',
  'Cutive',
  'Cutive Mono',
  'Chakra Petch',
  'Metrophobic',
  'Ceviche One',
  'Red Hat Display',
  'Schoolbell',
  'Encode Sans Expanded',
  'Duru Sans',
  'Shojumaru',
  'Freckle Face',
  'Mukta Vaani',
  'Rye',
  'Ovo',
  'Mr De Haviland',
  'Six Caps',
  'Andada',
  'Lexend Deca',
  'IBM Plex Sans Condensed',
  'Big Shoulders Text',
  'Amethysta',
  'Pompiere',
  'Vesper Libre',
  'Cormorant Infant',
  'Homenaje',
  'Federo',
  'McLaren',
  'Kadwa',
  'Laila',
  'Suez One',
  'Cedarville Cursive',
  'Fanwood Text',
  'Montez',
  'Black Han Sans',
  'IM Fell English',
  'IM Fell Double Pica',
  'Inder',
  'Unkempt',
  'Averia Serif Libre',
  'Emilys Candy',
  'Secular One',
  'Brawler',
  'Sansita',
  'Happy Monkey',
  'Balthazar',
  'Doppio One',
  'Rozha One',
  'Aref Ruqaa',
  'Mate',
  'Gabriela',
  'Chonburi',
  'Baumans',
  'Pangolin',
  'BioRhyme',
  'Noto Serif KR',
  'IM Fell DW Pica',
  'Amiko',
  'Megrim',
  'Corben',
  'Chelsea Market',
  'Oregano',
  'Athiti',
  'Convergence',
  'Geo',
  'Gravitas One',
  'Gurajada',
  'Short Stack',
  'Raleway Dots',
  'Battambang',
  'Kosugi',
  'Vast Shadow',
  'La Belle Aurore',
  'Lemon',
  'Fondamento',
  'Skranji',
  'Limelight',
  'Baloo Chettan',
  'UnifrakturMaguntia',
  'Proza Libre',
  'Seaweed Script',
  'Jua',
  'Denk One',
  'Qwigley',
  'Prociono',
  'Belgrano',
  'Alike',
  'Crafty Girls',
  'Wallpoet',
  'Sofia',
  'Waiting for the Sunrise',
  'Mallanna',
  'Carrois Gothic SC',
  'Spicy Rice',
  'Give You Glory',
  'Share Tech',
  'Rouge Script',
  'Cormorant SC',
  'Scope One',
  'Sniglet',
  'Kurale',
  'Patrick Hand SC',
  'Bowlby One',
  'Fjord One',
  'Cantora One',
  'Strait',
  'Quando',
  'Fresca',
  'Stardos Stencil',
  'Expletus Sans',
  'Finger Paint',
  'Zeyada',
  'Gafata',
  'Spectral SC',
  'Andika',
  'Podkova',
  'Amarante',
  'Oleo Script Swash Caps',
  'Crushed',
  'Cherry Swash',
  'Mirza',
  'Meddon',
  'Harmattan',
  'Faster One',
  'Aguafina Script',
  'Katibeh',
  'Loved by the King',
  'Amita',
  'Mouse Memoirs',
  'Nova Square',
  'Voces',
  'IM Fell English SC',
  'Tienne',
  'Esteban',
  'Delius Swash Caps',
  'Galada',
  'Libre Barcode 39',
  'Orienta',
  'Bilbo Swash Caps',
  'Clicker Script',
  'Literata',
  'Puritan',
  'Cormorant Upright',
  'Averia Sans Libre',
  'Wendy One',
  'Sedgwick Ave',
  'Baloo Da',
  'Mako',
  'Krona One',
  'Euphoria Script',
  'Bungee Shade',
  'Walter Turncoat',
  'Just Me Again Down Here',
  'Dawning of a New Day',
  'Baloo Thambi',
  'Averia Libre',
  'The Girl Next Door',
  'Alike Angular',
  'Tauri',
  'Charm',
  'Rationale',
  'Montserrat Subrayada',
  'Spirax',
  'Rammetto One',
  'Poller One',
  'Wire One',
  'Overlock SC',
  'Over the Rainbow',
  'Mrs Saint Delafield',
  'NTR',
  'Bellefair',
  'Fontdiner Swanky',
  'Imprima',
  'K2D',
  'Atma',
  'Ledger',
  'Rum Raisin',
  'Codystar',
  'Holtwood One SC',
  'Iceland',
  'Baloo Paaji',
  'Creepster',
  'Rakkas',
  'Life Savers',
  'Salsa',
  'Numans',
  'Princess Sofia',
  'Ruslan Display',
  'Pavanam',
  'Habibi',
  'Bubbler One',
  'Engagement',
  'Hanalei Fill',
  'Port Lligat Sans',
  'Dokdo',
  'Sarpanch',
  'Lily Script One',
  'Artifika',
  'Slackey',
  'Shanti',
  'Nova Mono',
  'Headland One',
  'Mandali',
  'Prosto One',
  'Song Myung',
  'Mogra',
  'Vampiro One',
  'Modak',
  'Asul',
  'Vibur',
  'Saira Stencil One',
  'David Libre',
  'Elsie',
  'Noto Sans HK',
  'Englebert',
  'Koulen',
  'Kranky',
  'B612 Mono',
  'Antic Didone',
  'Port Lligat Slab',
  'Vollkorn SC',
  'Cherry Cream Soda',
  'Frijole',
  'Manjari',
  'Sirin Stencil',
  'Zilla Slab Highlight',
  'Farsan',
  'Medula One',
  'Ranchers',
  'Eater',
  'Ruluko',
  'Livvic',
  'Padauk',
  'Kotta One',
  'Mukta Mahee',
  'Peralta',
  'Blinker',
  'Dynalight',
  'Kumar One',
  'Underdog',
  'IM Fell French Canon',
  'Metamorphous',
  'Arya',
  'Gugi',
  'Dekko',
  'Sail',
  'Buda',
  'Bilbo',
  'Coiny',
  'Nova Round',
  'Baloo Tamma',
  'Yatra One',
  'Mate SC',
  'Macondo Swash Caps',
  'Almendra',
  'Meera Inimai',
  'Sonsie One',
  'Pirata One',
  'Mystery Quest',
  'Khmer',
  'Germania One',
  'Donegal One',
  'Dorsa',
  'Sarina',
  'Inknut Antiqua',
  'Timmana',
  'Stint Ultra Condensed',
  'Flamenco',
  'Chau Philomene One',
  'Condiment',
  'Tulpen One',
  'Simonetta',
  'Milonga',
  'Chicle',
  'Manuale',
  'Thasadith',
  'Ramaraja',
  'Libre Caslon Text',
  'Fascinate Inline',
  'Rosarivo',
  'ZCOOL QingKe HuangYou',
  'Darker Grotesque',
  'Ranga',
  'Delius Unicase',
  'Junge',
  'Nova Slim',
  'Moul',
  'Kite One',
  'Gaegu',
  'Plaster',
  'Trade Winds',
  'Chathura',
  'Stalemate',
  'Paprika',
  'Fenix',
  'Ewert',
  'Italiana',
  'Miniver',
  'Almarai',
  'Ribeye Marrow',
  'Cagliostro',
  'Londrina Outline',
  'Jacques Francois Shadow',
  'Quintessential',
  'Mina',
  'Angkor',
  'Ribeye',
  'Nokora',
  'Henny Penny',
  'Galdeano',
  'Lovers Quarrel',
  'IM Fell Great Primer',
  'League Script',
  'Stoke',
  'Swanky and Moo Moo',
  'Cormorant Unicase',
  'Sura',
  'Srisakdi',
  'Diplomata',
  'IM Fell DW Pica SC',
  'Sancreek',
  'Averia Gruesa Libre',
  'Della Respira',
  'Text Me One',
  'Maiden Orange',
  'Glass Antiqua',
  'Julee',
  'Sumana',
  'Uncial Antiqua',
  'Petrona',
  'New Rocker',
  'Griffy',
  'Barriecito',
  'Linden Hill',
  'Farro',
  'Be Vietnam',
  'Nosifer',
  'Joti One',
  'Redressed',
  'Marko One',
  'Hepta Slab',
  'Vibes',
  'IM Fell French Canon SC',
  'Sree Krushnadevaraya',
  'Trochut',
  'Tillana',
  'Kavoon',
  'Big Shoulders Display',
  'Bokor',
  'Wellfleet',
  'Croissant One',
  'Chela One',
  'Grenze',
  'Eagle Lake',
  'Akronim',
  'Barrio',
  'Offside',
  'Stint Ultra Expanded',
  'Liu Jian Mao Cao',
  'Monsieur La Doulaise',
  'Margarine',
  'B612',
  'UnifrakturCook',
  'Revalia',
  'Chango',
  'Elsie Swash Caps',
  'Nova Flat',
  'Unlock',
  'Autour One',
  'Charmonman',
  'Bebas Neue',
  'Content',
  'Trykker',
  'Ruthie',
  'Inika',
  'Chilanka',
  'Monofett',
  'Notable',
  'Baloo Tammudu',
  'Kodchasan',
  'Oldenburg',
  'Irish Grover',
  'Rhodium Libre',
  'Mrs Sheppards',
  'Asar',
  'Smythe',
  'Metal Mania',
  'Montaga',
  'Hi Melody',
  'Iceberg',
  'KoHo',
  'Modern Antiqua',
  'Lakki Reddy',
  'Mansalva',
  'Bigshot One',
  'Crimson Pro',
  'Felipa',
  'Original Surfer',
  'Bahiana',
  'Smokum',
  'Fira Code',
  'Stylish',
  'Dr Sugiyama',
  'MedievalSharp',
  'Asset',
  'Meie Script',
  'Purple Purse',
  'IM Fell Great Primer SC',
  'Sahitya',
  'Libre Barcode 128',
  'Keania One',
  'Miltonian Tattoo',
  'Fahkwang',
  'Molle',
  'Devonshire',
  'Libre Barcode 39 Text',
  'Ruge Boogie',
  'Snowburst One',
  'Caesar Dressing',
  'Arbutus',
  'Poor Story',
  'Snippet',
  'Jim Nightshade',
  'Libre Barcode 39 Extended Text',
  'Bayon',
  'Ravi Prakash',
  'Odor Mean Chey',
  'Lancelot',
  'Risque',
  'Atomic Age',
  'Dangrek',
  'Londrina Shadow',
  'ZCOOL KuaiLe',
  'Freehand',
  'Libre Barcode 39 Extended',
  'IM Fell Double Pica SC',
  'Goblin One',
  'Major Mono Display',
  'Diplomata SC',
  'Kantumruy',
  'Yeon Sung',
  'Cute Font',
  'Seymour One',
  'Gorditas',
  'Gamja Flower',
  'Kavivanar',
  'Jacques Francois',
  'Kumar One Outline',
  'Jolly Lodger',
  'Kenia',
  'Sunshiney',
  'Flavors',
  'Astloch',
  'GFS Neohellenic',
  'Black And White Picture',
  'Nova Cut',
  'Butterfly Kids',
  'Almendra SC',
  'Piedra',
  'Almendra Display',
  'Romanesco',
  'Suwannaphum',
  'Miltonian',
  'Siemreap',
  'Tenali Ramakrishna',
  'Kirang Haerang',
  'Alata',
  'Bungee Outline',
  'Macondo',
  'East Sea Dokdo',
  'Fruktur',
  'Supermercado One',
  'Jomhuria',
  'Nova Script',
  'Nova Oval',
  'Galindo',
  'Bigelow Rules',
  'Metal',
  'Combo',
  'Sedgwick Ave Display',
  'Jomolhari',
  'Miss Fajardose',
  'Erica One',
  'Passero One',
  'Geostar Fill',
  'Aubrey',
  'Bonbon',
  'Emblema One',
  'Londrina Sketch',
  'Sevillana',
  'Butcherman',
  'Libre Barcode 128 Text',
  'Taprom',
  'Mr Bedfort',
  'Sofadi One',
  'Geostar',
  'Preahvihear',
  'Gidugu',
  'Kdam Thmor',
  'Hanalei',
  'Bungee Hairline',
  'Peddana',
  'Suravaram',
  'Calistoga',
  'Fascinate',
  'Public Sans',
  'Federant',
  'Libre Caslon Display',
  'Lexend Exa',
  'Chenla',
  'Stalinist One',
  'Moulpali',
  'Beth Ellen',
  'Dhurjati',
  'Alatsi',
  'Lexend Tera',
  'Fasthand',
  'Gayathri',
  'BioRhyme Expanded',
  'Tomorrow',
  'Ma Shan Zheng',
  'Warnes',
  'Turret Road',
  'Lacquer',
  'Single Day',
  'Lexend Mega',
  'Lexend Zetta',
  'Odibee Sans',
  'Zhi Mang Xing',
  'Lexend Peta',
  'Lexend Giga',
  'Kulim Park',
  'Bahianita',
  'Long Cang',
  'Ibarra Real Nova',
  'Baskervville',
  'Sulphur Point',
  'Solway',
  'Gupter',
  'Inter',
];
